import _ from 'lodash';
import moment from 'moment';
import { createApp, defineComponent } from 'vue';
import GridCustomColumnEditor from './GridCustomColumnEditor.vue';
import userCustomColumns from '../../../controllers/userCustomColumns';
import constants from '$$helpers/constants/';
import globalToast from '$$vueCmp/toast';
import dateFormatHelper from '$$dateFormatsHelper';
import KeyboardNavigation from '../../keyboardNavigation';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridCustomColumnEditor);

      const options = instance.config.columns.find(col => col.control_id === column.control_id).control_options;
      const onSave = () => {
        instance.ext.inlineEditors.save();
      };
      const onCancel = () => {
        instance.ext.inlineEditors.hide();
      };

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder, {
        placeholder,
        column,
        options,
        onSave,
        onCancel
      });
      vueInstance = vueApp.mount(placeholder);

      if (column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id) {
        KeyboardNavigation.toggleState(false);
      }
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;

      if (vueInstance.column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id) {
        KeyboardNavigation.toggleState(true);
      }

      vueInstance = null;
    },

    set_value(task, id, column, node) {
      vueInstance.value = userCustomColumns.getUserCustomValue(task, column.name).value;

      if (column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id && vueInstance.value) {
        const format = dateFormatHelper.getDateFormat().trim();
        const date = new Date(vueInstance.value);

        vueInstance.value = instance.date.date_to_str(format)(date);
        vueInstance.datePickerValue = vueInstance.value;
      }
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, id, column, node) {
      if (column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id) {
        const formater = dateFormatHelper.convertGanttDateFormat(false);
        let vueValue = vueInstance.value;

        if (_.isString(vueValue) && vueValue.length) {
          vueValue = moment(vueValue.trim(), formater, true).toDate();
        }

        return userCustomColumns.getUserCustomValue(task, column.name).value?.valueOf() !== vueValue?.valueOf();
      }

      return true;
    },

    is_valid(value, id, column, node) {
      if (column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id) {
        const formater = dateFormatHelper.convertGanttDateFormat(false);

        if (_.isString(value) && value === '') {
          return true;
        }

        if (_.isString(value) && moment(value.trim(), formater, true).isValid()) {
          return true;
        }

        if (value && (value instanceof Date) && value.getTime()) {
          return true;
        }

        globalToast.warning(__('gantt_date_invalid'));

        return false;
      }

      return true;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const type = column.data_type.split('_')[1];

      const oldValue = userCustomColumns.getUserCustomValue(task, column.name).value;
      let value = vueInstance.value;

      if (column.columnType === constants.CUSTOM_COLUMNS_TYPES.date.id) {
        const formater = dateFormatHelper.convertGanttDateFormat(false);

        if (_.isString(value) && value.length) {
          value = moment(value.trim(), formater, true).toDate();
        }
      }

      if (_.isDate(oldValue) && _.isDate(value)) {
        if (value.getTime() !== oldValue.getTime()) {
          instance.ganttDataApi.changeUserCustomValue(task, column.name, value);

          userExtAnalytics.log('task_grid_action', { action: 'custom_field', type });
        }

        return;
      }

      if (!(!value && !oldValue) && (value !== oldValue)) {
        instance.ganttDataApi.changeUserCustomValue(task, column.id, value);

        userExtAnalytics.log('task_grid_action', { action: 'custom_field', type });
      }
    },

    focus(node) {
    },
  };
}
